export default {
  "loading": "Loading",
  "feedbackMessages": {
    "badNps": {
      "message1": "Thanks for your opinion",
      "message2": "¡We are going to improve!"
    },
    "regularNps": {
      "message1": "Thanks for your opinion",
      "message2": "¡We will keep improving!"
    },
    "goodNps": {
      "message1": "Thank you so much for your opinion",
      "message2": "¡It is very important for us!"
    },
    "error": {
      "message1": "An error has occurred",
      "message2": "Try refreshing to start again"
    }
  },
  "disclaimer": "This survey is not anonymous, which will allow us to contact you for your feedback and suggestions."
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/survey/index.js